import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';
import React from 'react';

export const StartFilled = Styled(
	createSvgIcon(
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM8.622 6.415C8.56182 6.37485 8.49187 6.35177 8.41961 6.34822C8.34734 6.34467 8.27547 6.36079 8.21165 6.39486C8.14782 6.42893 8.09443 6.47967 8.05716 6.54168C8.01989 6.60369 8.00013 6.67465 8 6.747V13.253C8.00013 13.3253 8.01989 13.3963 8.05716 13.4583C8.09443 13.5203 8.14782 13.5711 8.21165 13.6051C8.27547 13.6392 8.34734 13.6553 8.41961 13.6518C8.49187 13.6482 8.56182 13.6252 8.622 13.585L13.501 10.333C13.5559 10.2965 13.6009 10.247 13.632 10.1889C13.6631 10.1308 13.6794 10.0659 13.6794 10C13.6794 9.93409 13.6631 9.86921 13.632 9.81111C13.6009 9.75302 13.5559 9.70351 13.501 9.667L8.622 6.415Z'
				fill='currentColor'
			/>
		</svg>,
		'StartFilled'
	)
);

export default StartFilled;
